function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var useTrackingCode = function useTrackingCode() {
  var _hsq = window._hsq || [];

  var setTrackPageView = function setTrackPageView() {
    _hsq.push(["trackPageView"]);
  };

  var setPathPageView = function setPathPageView(path) {
    // This function updates the path
    _hsq.push(["setPath", path]); // This function track the current updated page path


    setTrackPageView();
  };

  var setIdentity = function setIdentity(email, customPropertities) {
    _hsq.push(["identify", _extends({
      email: email
    }, customPropertities)]);
  };

  var setTrackEvent = function setTrackEvent(_ref) {
    var eventId = _ref.eventId,
        value = _ref.value;

    _hsq.push(["trackEvent", {
      id: eventId,
      value: value
    }]);
  };

  return {
    setPathPageView: setPathPageView,
    setTrackPageView: setTrackPageView,
    setIdentity: setIdentity,
    setTrackEvent: setTrackEvent
  };
};

export { useTrackingCode };
//# sourceMappingURL=react-hubspot-tracking-code-hook.esm.js.map
